import { useEffect } from 'react';

export function useScrollReveal(ref, options = {}) {
  const { threshold = 0.15, rootMargin = '0px' } = options;

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const elements = node.querySelectorAll('.reveal, .reveal-fade, .reveal-scale');
    if (elements.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold, rootMargin }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [ref, threshold, rootMargin]);
}
